import { RouterBuilder } from "@/components/routerBuilder/RouterBuilder";
import { Log } from "@/models/logging/log";
import { initTrackOptions } from "@/services/log/initTrackOptions";
import { logMiddlewareActivator } from "@/services/log/logMiddlewareActivator";
import envSettings from "@/services/system/envSettings";
import { useEffect } from "react";
import { useTracking } from "react-tracking";
import { useAddLogDataMutation } from "./api/infrastructureApi";
import { selectIdentifier, selectInitializeToken } from "./slices/authSlice";
import { selectErrorLog, selectFulfilledLog } from "./slices/logSlice";
import { useAppDispatch, useTypedSelector } from "./stores/store";

const trackOptions = initTrackOptions();

const App = () => {
  const [addLogData] = useAddLogDataMutation();
  const dispatch = useAppDispatch();
  const identifier = useTypedSelector(selectIdentifier);
  const initializeToken = useTypedSelector(selectInitializeToken);
  const fulfilledLog = useTypedSelector(selectFulfilledLog);
  const errorLog = useTypedSelector(selectErrorLog);

  const { Track } = useTracking(trackOptions, {
    dispatch: (trackingData: Log) => {
      trackingData.cprNumber = identifier;
      if (envSettings.SEND_LOGS === true) {
        addLogData(trackingData);
      }
    },
  });

  useEffect(() => {
    logMiddlewareActivator(initializeToken, fulfilledLog, errorLog);
  }, [dispatch, errorLog, fulfilledLog, initializeToken]);

  return (
    <Track>
      <RouterBuilder />
    </Track>
  );
};

export default App;
